/**
 * LEDGER POINTS on a quest — not the 0-100 completeness score in scoreQuest.
 *
 * completeStep refuses catalog measured steps, so those weights never write a
 * quest-step ledger row. scoreQuest also labels a click step completedBy
 * 'measured' once progress hits 1; the checkbox then disables and no ledger
 * row is written either. Click/manual completions pay weight. The completion
 * bonus (pointsReward) pays once at 100%. Buddy bonuses stay out: they depend
 * on someone else showing up, and a denominator she cannot reach alone is a
 * worse number than no denominator.
 */

export type LedgerQuestStep = {
  weight: number;
  complete?: boolean;
  completedBy?: 'measured' | 'click' | 'manual' | string | null;
  completion?: 'measured' | 'click' | string | null;
};

export type LedgerQuestPoints = {
  complete?: boolean;
  pointsReward?: number | null;
};

/** Weights the ledger can actually pay on this quest, plus the finish bonus. */
export function questPointsAvailable(steps: ReadonlyArray<LedgerQuestStep>, pointsReward?: number | null): number {
  const stepPoints = steps.reduce((memo, step) => {
    if (step.completion === 'measured' || step.completedBy === 'measured') return memo;
    return memo + (step.weight ?? 0);
  }, 0);
  return stepPoints + (pointsReward ?? 0);
}

/** What the ledger paid so far: stored click/manual weights + finish bonus. */
export function questPointsEarned(steps: ReadonlyArray<LedgerQuestStep>, opts: LedgerQuestPoints = {}): number {
  const stepPoints = steps.reduce((memo, step) => {
    if (!step.complete || step.completedBy === 'measured') return memo;
    return memo + (step.weight ?? 0);
  }, 0);
  return stepPoints + (opts.complete ? (opts.pointsReward ?? 0) : 0);
}
